import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import React from "react";
import { redColor } from "../../config/ColorObj";

const ProductRateStructureTable = ({
    matrixDataList,
    onChange,
    stockHolderTypeList,
    getFilteredTableData,

}) => {


    const getFilteredTableDataForTable = (data) => {
        return getFilteredTableData(data);
    };

    const filteredData =
        matrixDataList.length !== 0 ? getFilteredTableDataForTable(matrixDataList) : [];

    const onChangeForTable = (e, productObject) => {
        onChange(e, productObject);
    }

    const isReverse = localStorage.getItem("showReverseSequenceForProductRateStructure");

    return (

        <TableContainer sx={{ maxHeight: 440 }} component={Paper}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell
                            align="center"
                            style={{
                                minWidth: "70px",
                                position: "sticky",
                                left: 0,
                                background: "#fff",
                                zIndex: 11,
                            }}
                        >
                            Sr. No.
                        </TableCell>
                        <TableCell
                            align="center"
                            style={{
                                minWidth: "150px",
                                position: "sticky",
                                left: 70,
                                background: "#fff",
                                zIndex: 11,
                            }}
                        >
                            Brand
                        </TableCell>
                        <TableCell
                            align="center"
                            style={{
                                minWidth: "150px",
                                position: "sticky",
                                left: 220,
                                background: "#fff",
                                zIndex: 11,
                            }}
                        >
                            Product Name
                        </TableCell>
                        <TableCell
                            align="center"
                            style={{
                                minWidth: "150px",
                                position: "sticky",
                                left: 370,
                                background: "#fff",
                                zIndex: 11,
                            }}
                        >
                            Category
                        </TableCell>

                        {isReverse !== null && isReverse == 1 ? (
                            <>
                                {stockHolderTypeList.map(
                                    (stakeHolderObject) => {
                                        return (
                                            <TableCell
                                                align="center"
                                                style={{ minWidth: "150px" }}
                                                key={stakeHolderObject.name}
                                            >
                                                {stakeHolderObject.name}
                                            </TableCell>
                                        );
                                    }
                                )}
                                <TableCell align="center" style={{ minWidth: "150px" }}>
                                    Outlet Rate
                                </TableCell>
                                <TableCell align="center" style={{ minWidth: "150px" }}>
                                    MRP Rate
                                </TableCell>
                            </>
                        ) : (
                            <>
                                <TableCell align="center" style={{ minWidth: "150px" }}>
                                    MRP Rate
                                </TableCell>
                                <TableCell align="center" style={{ minWidth: "150px" }}>
                                    Outlet Rate
                                </TableCell>
                                {stockHolderTypeList.map(
                                    (stakeHolderObject) => {
                                        return (
                                            <TableCell
                                                align="center"
                                                style={{ minWidth: "150px" }}
                                                key={stakeHolderObject.name}
                                            >
                                                {stakeHolderObject.name}
                                            </TableCell>
                                        );
                                    }
                                )}

                            </>
                        )}

                        {localStorage.getItem(
                            "radioPurchasereturnAndExpiryForRatestructure"
                        ) &&
                            localStorage.getItem(
                                "radioPurchasereturnAndExpiryForRatestructure"
                            ) == 1 ? (
                            <>
                                <TableCell align="center" style={{ minWidth: "150px" }}>
                                    Expiry Rate
                                </TableCell>
                            </>
                        ) : null}

                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredData.map(
                        (productObject, indexRow) => {
                            return (
                                <TableRow>
                                    <TableCell
                                        align="center"
                                        component="td"
                                        scope="row"
                                        style={{
                                            position: "sticky",
                                            left: 0,
                                            background: "white",
                                            zIndex: 1,
                                        }}
                                    >
                                        {indexRow + 1}
                                    </TableCell>
                                    <TableCell
                                        component="td"
                                        scope="row"
                                        style={{
                                            position: "sticky",
                                            left: "70px",
                                            background: "white",
                                            zIndex: 1,
                                        }}
                                    >
                                        {productObject.brandName}
                                    </TableCell>
                                    <TableCell
                                        component="td"
                                        scope="row"
                                        style={{
                                            position: "sticky",
                                            left: "220px",
                                            background: "white",
                                            zIndex: 1,
                                        }}
                                    >
                                        {productObject.productName}
                                    </TableCell>
                                    <TableCell
                                        component="td"
                                        scope="row"
                                        style={{
                                            minWidth: "150px",
                                            position: "sticky",
                                            left: 370,
                                            background: "#fff",
                                        }}
                                    >
                                        {productObject.categtoryName}
                                    </TableCell>

                                    {isReverse !== null && isReverse == 1 ? (
                                        <>
                                            {stockHolderTypeList.map(
                                                (stakeHolderObject, index) => {

                                                    const normalizedName = stakeHolderObject.name
                                                        .toLowerCase()
                                                        .replaceAll(" ", "");

                                                    return (
                                                        <TableCell align="right">
                                                            <input
                                                                className={"customTextfield"}
                                                                placeHolder={stakeHolderObject.name + " Rate"}
                                                                value={
                                                                    productObject[
                                                                    stakeHolderObject.name
                                                                        .replaceAll(" ", "")
                                                                        .toLowerCase()
                                                                    ]
                                                                }
                                                                name={stakeHolderObject.name
                                                                    .replaceAll(" ", "")
                                                                    .toLowerCase()}
                                                                onChange={(e) =>
                                                                    onChangeForTable(e, productObject)
                                                                }
                                                                type="text"
                                                                id={stakeHolderObject.name
                                                                    .replaceAll(" ", "")
                                                                    .toLowerCase()}
                                                            ></input>

                                                            {/* Empty value error */}
                                                            {productObject[normalizedName] === "" && (
                                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                                    Rate Required
                                                                </span>
                                                            )}

                                                            {/* Super Stockist error */}
                                                            {normalizedName.includes("superstockist") && productObject.superstockistError && (
                                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                                    Rate Should be smaller than Distributor
                                                                </span>
                                                            )}

                                                            {/* Stockist error (excluding superstockist) */}
                                                            {normalizedName.includes("stockist") &&
                                                                !normalizedName.includes("superstockist") &&
                                                                productObject.stockistError && (
                                                                    <span style={{ color: redColor, fontSize: "12px" }}>
                                                                        Rate Should be smaller than Distributor
                                                                    </span>
                                                                )}

                                                            {/* Distributor error - message depends on sub distributor existence */}
                                                            {normalizedName === "distributor" && productObject.distributorError && (
                                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                                    "Rate Should be smaller than Outlet Rate"
                                                                </span>
                                                            )}


                                                        </TableCell>
                                                    );
                                                }
                                            )}

                                            <TableCell align="right">
                                                <input
                                                    className={"customTextfield"}
                                                    placeHolder={"Outlet Rate"}
                                                    value={productObject.outletRate}
                                                    name="outletRate"
                                                    onChange={(e) => onChangeForTable(e, productObject)}
                                                    type="text"
                                                    id="outletRate"
                                                ></input>

                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                    {productObject.outletRate === "" ||
                                                        (productObject.stockist == 0 &&
                                                            productObject.outletRateError)
                                                        ? "Rate Required"
                                                        : productObject.outletRateError
                                                            ? "Rate Should be smaller than MRP"
                                                            : ""}
                                                </span>
                                            </TableCell>

                                            <TableCell align="right">
                                                <input
                                                    className={"customTextfield"}
                                                    min="0"
                                                    step=".01"
                                                    placeHolder={"MRP Rate"}
                                                    value={productObject.mrp}
                                                    name="mrp"
                                                    onChange={(e) => onChangeForTable(e, productObject)}
                                                    type="number"
                                                    id="mrp"
                                                ></input>
                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                    {productObject.mrp === "" ||
                                                        (productObject.mrp == 0 && productObject.mrpError)
                                                        ? "MRP Required "
                                                        : ""}
                                                </span>
                                            </TableCell>
                                        </>
                                    ) : (
                                        <>
                                            <TableCell align="right">
                                                <input
                                                    className={"customTextfield"}
                                                    min="0"
                                                    step=".01"
                                                    placeHolder={"MRP Rate"}
                                                    value={productObject.mrp}
                                                    name="mrp"
                                                    onChange={(e) => onChangeForTable(e, productObject)}
                                                    type="number"
                                                    id="mrp"
                                                ></input>
                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                    {productObject.mrp === "" ||
                                                        (productObject.mrp == 0 && productObject.mrpError)
                                                        ? "MRP Required "
                                                        : ""}
                                                </span>
                                            </TableCell>

                                            <TableCell align="right">
                                                <input
                                                    className={"customTextfield"}
                                                    placeHolder={"Outlet Rate"}
                                                    value={productObject.outletRate}
                                                    name="outletRate"
                                                    onChange={(e) => onChangeForTable(e, productObject)}
                                                    type="text"
                                                    id="outletRate"
                                                ></input>

                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                    {productObject.outletRate === "" ||
                                                        (productObject.stockist == 0 &&
                                                            productObject.outletRateError)
                                                        ? "Rate Required"
                                                        : productObject.outletRateError
                                                            ? "Rate Should be smaller than MRP"
                                                            : ""}
                                                </span>
                                            </TableCell>

                                            {stockHolderTypeList.map(
                                                (stakeHolderObject, index) => {

                                                    const normalizedName = stakeHolderObject.name
                                                        .toLowerCase()
                                                        .replaceAll(" ", "");

                                                    const hasSubDistributor = stockHolderTypeList.some(
                                                        sh => sh.name.toLowerCase().replaceAll(" ", "") === "subdistributor"
                                                    );

                                                    return (
                                                        <TableCell align="right">
                                                            <input
                                                                className={"customTextfield"}
                                                                placeHolder={stakeHolderObject.name + " Rate"}
                                                                value={
                                                                    productObject[
                                                                    stakeHolderObject.name
                                                                        .replaceAll(" ", "")
                                                                        .toLowerCase()
                                                                    ]
                                                                }
                                                                name={stakeHolderObject.name
                                                                    .replaceAll(" ", "")
                                                                    .toLowerCase()}
                                                                onChange={(e) =>
                                                                    onChangeForTable(e, productObject)
                                                                }
                                                                type="text"
                                                                id={stakeHolderObject.name
                                                                    .replaceAll(" ", "")
                                                                    .toLowerCase()}
                                                            ></input>

                                                            {/* Empty value error */}
                                                            {productObject[normalizedName] === "" && (
                                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                                    Rate Required
                                                                </span>
                                                            )}

                                                            {/* Super Stockist error */}
                                                            {normalizedName.includes("superstockist") && productObject.superstockistError && (
                                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                                    Rate Should be smaller than Distributor
                                                                </span>
                                                            )}

                                                            {/* Stockist error (excluding superstockist) */}
                                                            {normalizedName.includes("stockist") &&
                                                                !normalizedName.includes("superstockist") &&
                                                                productObject.stockistError && (
                                                                    <span style={{ color: redColor, fontSize: "12px" }}>
                                                                        Rate Should be smaller than Distributor
                                                                    </span>
                                                                )}

                                                            {/* Sub Distributor error */}
                                                            {normalizedName === "subdistributor" && productObject.subdistributorError && (
                                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                                    Rate Should be smaller than Outlet Rate
                                                                </span>
                                                            )}

                                                            {/* Distributor error - message depends on sub distributor existence */}
                                                            {normalizedName === "distributor" && productObject.distributorError && (
                                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                                    {hasSubDistributor
                                                                        ? "Rate Should be smaller than Sub Distributor"
                                                                        : "Rate Should be smaller than Outlet Rate"}
                                                                </span>
                                                            )}
                                                        </TableCell>
                                                    );
                                                }
                                            )}
                                        </>
                                    )}



                                    {localStorage.getItem(
                                        "radioPurchasereturnAndExpiryForRatestructure"
                                    ) &&
                                        localStorage.getItem(
                                            "radioPurchasereturnAndExpiryForRatestructure"
                                        ) == 1 ? (
                                        <>
                                            <TableCell align="right">
                                                <input
                                                    className={"customTextfield"}
                                                    placeHolder={"Expiry Rate"}
                                                    value={productObject.expiryRate}
                                                    name="expiryRate"
                                                    onChange={(e) => onChangeForTable(e, productObject)}
                                                    type="text"
                                                    id="expiryRate"
                                                ></input>

                                                <span style={{ color: redColor, fontSize: "12px" }}>
                                                    {productObject.expiryRate === ""
                                                        ? "Rate Required"
                                                        : " "}
                                                </span>
                                            </TableCell>
                                        </>
                                    ) : null}

                                </TableRow>
                            );
                        }
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ProductRateStructureTable;
